import {SessionService} from './session';
import {Injectable} from '@angular/core';

@Injectable()
export class BeautyFiltersService {
  constructor(public sessionService: SessionService) {
  }

  queryParams = {
    from_date: '',
    to_date: '',
    latitude: '',
    longitude: '',
    radius: '',
    touched: false,
    structure: {lower: 5, upper: 23},
    services: [],
    city: this.sessionService.user.city_id,
    zones: [],
    categories: [],
    gym: []
  }

  classType = '';
  myClassesType = 'reserved'
  showMap= false;
  hideMapForShowingOnStudio = false; // need to remove map in order to open map in new page
  loadedAllMyClasses = false;
}



// WEBPACK FOOTER //
// ./src/services/beauty-filters.ts